import EntityName from '../../enums/EntityName';
import EntityType from '../../types/Entity';
import { createAction } from '../../utils/action';
import { RestErrorResponse } from '../../types/response/RestErrorResponse';
import { getActionTypeByName } from '../helpers';

export const generateEntityGetActions = (entityName: EntityName) => {
  return {
    get: () => createAction(getActionTypeByName(`GET_${entityName}`)),
    getSuccess: (stateDelta: any) => createAction(getActionTypeByName(`GET_${entityName}_SUCCESS`), stateDelta),
    getError: (error: RestErrorResponse) => createAction(getActionTypeByName(`GET_${entityName}_ERROR`), error)
  };
};

export const generateEntityGetListActions = <T extends EntityType>(entityName: EntityName) => {
  return {
    getList: () => createAction(getActionTypeByName(`GET_${entityName}_LIST`)),
    getListSuccess: (list: T[]) => createAction(getActionTypeByName(`GET_${entityName}_LIST_SUCCESS`), list),
    getListError: (error: RestErrorResponse) => createAction(getActionTypeByName(`GET_${entityName}_LIST_ERROR`), error)
  };
};

export const generateEntityCreateActions = <T extends EntityType>(entityName: EntityName) => {
  return {
    create: (entity: Partial<T>) => createAction(getActionTypeByName(`CREATE_${entityName}`), entity),
    createSuccess: (stateDelta: any) => createAction(getActionTypeByName(`CREATE_${entityName}_SUCCESS`), stateDelta),
    createError: (error: RestErrorResponse) => createAction(getActionTypeByName(`CREATE_${entityName}_ERROR`), error)
  };
};
